import type { PublicContext } from "../trpc"
import type { Contact } from "@prisma/client"
import { withContactLock } from "../services/contact/contact-lock"

export function normalizeEmail(email: string): string {
	return email.toLowerCase().trim()
}

interface FindOrCreateContactParams {
	email: string
	workspaceId: string
}

export async function findOrCreateContact(
	{ email, workspaceId }: FindOrCreateContactParams,
	ctx: PublicContext,
): Promise<Contact> {
	const normalizedEmail = normalizeEmail(email)
	const existing = await ctx.prisma.contact.findFirst({
		where: {
			email: normalizedEmail,
			workspaceId,
			isDeleted: false,
		},
	})
	if (existing) return existing

	// Serialize check-then-create so two concurrent callers for the same email
	// return one shared row instead of each inserting a duplicate.
	return withContactLock(
		ctx.prisma,
		workspaceId,
		normalizedEmail,
		async (tx) => {
			const raced = await tx.contact.findFirst({
				where: { email: normalizedEmail, workspaceId, isDeleted: false },
			})
			if (raced) return raced
			return tx.contact.create({
				data: { email: normalizedEmail, workspaceId },
			})
		},
	)
}
